import axios from 'axios';

const get = async (groupId: string) => {
  const { data } = await axios.get(`/group/${groupId}`);
  return data;
};

export default get;
